/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";







@Injectable({
    providedIn: 'root'
})

export class ProgressIndicatorService {
    private _isloaderactive: BehaviorSubject<boolean>;
    isloaderactive$: Observable<boolean>;

    constructor() {

        this._isloaderactive = new BehaviorSubject<boolean>(false);
        this.isloaderactive$ = this._isloaderactive.asObservable();

    }

    show(isActive: boolean) {
        this._isloaderactive.next(isActive);
    }


}